import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const initialState = {
    status: null,
    message: null,
    httpStatusCode: null,
    configId: null,
    custId: null
}


export const createSassStore = createAsyncThunk("createSassStore", async (credentials) => {
    try {
        const response = await fetch(`/api/createStore`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(credentials)
        })
        if (!response.ok) {
            // Try to read the error message from the response body
            const errorData = await response.json();
            throw new Error(errorData.errorMessage);
        }
        return await response.json();
    } catch (error) {
        throw new Error(error);
    }
});

const storesSlice = createSlice({
    name: "createSassStore",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(createSassStore.pending, (state) => {
            state.status = "Loading"
            state.message = "Please wait"
        });
        builder.addCase(createSassStore.fulfilled, (state, action) => {
            state.status = "success"
            state.message = "Configuration created successfully"
            state.httpStatusCode = action.payload.data.httpStatusCode
            state.custId = action.payload.data.data.struCustomerId
            state.configId = action.payload.data.data.struConfigId
        });
        builder.addCase(createSassStore.rejected, (state, action) => {
            let errMsg = action.error.message.replace("Error: ", "")
            state.status = "error"
            state.message = errMsg
        });
    }
})

export default storesSlice.reducer